// extracted by mini-css-extract-plugin
module.exports = {"dateInput":"DateInput_dateInput__2yIHD"};